import { useTranslation } from '@/i18n/useTranslation';

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);

  return (
    <nav className="flex-between" aria-label={t('Pagination')}>
      <span style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-muted)' }}>
        {t('Showing {from}–{to} of {total}', { from, to, total })}
      </span>
      <div className="cluster">
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label={t('Previous page')}
        >
          {t('← Prev')}
        </button>
        <span className="font-mono" aria-current="page">
          {t('Page {page} / {totalPages}', { page, totalPages })}
        </span>
        <button
          type="button"
          className="btn btn--secondary btn--sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          aria-label={t('Next page')}
        >
          {t('Next →')}
        </button>
      </div>
    </nav>
  );
}
